<template>
  <div class="content">
    <div class="content-data">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="Pagination.current_page"
          :page-size="Pagination.per_page"
          layout="total,prev, pager, next, jumper"
          :total="Pagination.total"
        >
        </el-pagination>
        <div class="line">
          当前页<span class="margin-left">{{ tableData.length }}</span
          >条
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    Pagination: {
      type: Object,
      default: "",
    },

    tableData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
  },
};
</script>
<style lang='less' scoped>
.block {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.content-data {
  margin: 15px 0;
}

.line {
  line-height: 25px;
}
.margin-left {
  margin: 0 2px;
}
</style>